import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import AuthFormParams, {AuthFormByTokenParams} from "./OrderResultModel/AuthFormParams"

export default function AuthFormProcessObservable(params: AuthFormParams): Observable<string> {
  const requestBody: string = JSON.stringify({
    FormFoxTestAN: params.FormFoxTestAN,
    PersonID: params.PersonID,
    VendorID: params.VendorID,
    SendToEmail: params.SendToEmail,
    SendText: params.SendText,
    EmailAddress: params.EmailAddress,
    ClientDetails: { },
  })

  return ObservableFromFetch<string>("WorkforceReport/TrackingAuthorizationForm", requestBody)
}

export  function AuthFormByToken(params: AuthFormByTokenParams): Observable<string> {
  const requestBody: string = JSON.stringify({
    requestToken: params.requestToken,
    FormFoxTestAN: params.FormFoxTestAN
  })

  return ObservableFromFetch<string>("WorkforceReport/AuthorizationFormByToken", requestBody)
}